import {
  Alert,
  DashboardTimeZone,
  datePresetOptions,
  FilterControl,
  FilterControlType,
  Page,
  ReportGroupPanel,
  timeFor,
  useDashboardSearch,
  type AnalyticsSource,
} from 'corso-admin-ui';
import { analyticsCatalog } from 'corso-types';
import { Navigate, useLocation } from 'react-router-dom';
import { match } from 'ts-pattern';
import api from '~/api';
import { platformReportGroups } from './reportGroups';

// every store, so amounts are the USD protection prices; counts and rates have no currency
const source = {
  key: ['platform'],
  currency: 'USD',
  query: api.analytics.query,
  list: api.analytics.lists.query,
} satisfies AnalyticsSource;
// stores span every zone, so days are the viewer's own
const timeZone = { key: DashboardTimeZone.local } as const;
// no selections beside the ones every dashboard has
const commandSearch = {};

export const DashboardsPage = () => {
  const {
    date,
    setDate,
    group: chosen,
    ...search
  } = useDashboardSearch(commandSearch);
  const location = useLocation();
  const [firstGroup] = platformReportGroups;
  const activeGroup =
    platformReportGroups.find(({ key }) => key === chosen) ?? firstGroup;

  // a link to no dashboard, or one that doesn't exist, opens the first
  if (activeGroup.key !== chosen) {
    return (
      <Navigate
        to={{
          pathname: `/dashboards/${activeGroup.key}`,
          search: location.search,
        }}
        replace
      />
    );
  }

  return (
    <Page
      title={activeGroup.label}
      size="fullWidth"
      overrideActions={
        <FilterControl
          filter={{
            id: 'date',
            type: FilterControlType.date,
            label: 'Date',
            verb: 'is',
            options: datePresetOptions,
            value: date,
          }}
          onChange={({ value }) => setDate(value)}
        />
      }
    >
      {match(timeFor(date, timeZone))
        .with(null, () => (
          <Alert
            variant="info"
            heading={`Choose a start date no more than ${analyticsCatalog.limits.maxRangeDays} days before the end date.`}
          />
        ))
        .otherwise(() => (
          <ReportGroupPanel
            key={activeGroup.key}
            source={source}
            group={activeGroup}
            date={date}
            view={{ ...search, timeZone }}
            offersFilters={false}
          />
        ))}
    </Page>
  );
};
